import { render } from "./FeeCard.vue?vue&type=template&id=5597c89a"
import script from "./FeeCard.vue?vue&type=script&lang=js"
export * from "./FeeCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__